module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "ct",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/preface#pageix"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/acknowledgment#pagexvii"
    }
  }, [_vm._v("Acknowledgments ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-level"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/part01#page1"
    }
  }, [_vm._v("Part One | Theories of Community ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-level1"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/ch01#page3"
    }
  }, [_c('span', {
    staticClass: "toc-level2-label"
  }, [_vm._v("1")]), _vm._v(" Nancy contra Stevens ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-level"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/part02#page37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two | Franz Kafka: Premonitions of Auschwitz ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-level1"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/ch02#page39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-level2-label"
  }, [_vm._v("2")]), _vm._v(" Foreshadowings of Auschwitz in Kafka's Writings ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-level1"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/ch03#page67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-level2-label"
  }, [_vm._v("3")]), _vm._v(" The Breakdown of Community and the Disabling of Speech Acts in Kafka's "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Trial")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-level1"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/ch04#page103",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-level2-label"
  }, [_vm._v("4")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Castle")]), _vm._v(": No "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mitsein")]), _vm._v(", No Verifiable Interpretation ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-level"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/part03#page147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three | Holocaust Novels ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-level1"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/prologue#page149",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-level2-label"
  }), _vm._v(" Prologue: Community in Fiction after Auschwitz ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-level1"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/ch05#page155",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-level2-label"
  }, [_vm._v("5")]), _vm._v(" Three Novels about the Shoah ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-level1"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/ch06#page177",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-level2-label"
  }, [_vm._v("6")]), _vm._v(" Imre Kertész's "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fatelessness")]), _vm._v(": Fiction as Testimony ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-level"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/part04#page229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four | Fiction after Auschwitz ")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-level1"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/ch07#page231",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-level2-label"
  }, [_vm._v("7")]), _vm._v(" Morrison's "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beloved")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/coda#page271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coda ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/notes_split_000#page273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/Text/index#page301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Names, Titles of Works, and Characters ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bbac37d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/toc.vue
// module id = 66
// module chunks = 0